import React,{useState,useEffect}  from 'react';
import {
    Form,Button, Select,Modal
} from 'antd';

import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required, FieldSelectNormalEditar,textArea } from '../../app/inputs/InputField';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetCategorias, actionAgregarCategoria } from '../../../store/acciones/accionesCatalogo';
import FormAgregarCategoria from './FormAgregarCategoria';

const Option = Select.Option;


let FormAgregarProducto = props => {
  const [visible, showModal]=useState(false)

  let categorias = useSelector(state => state.reducerCatalogo.categorias);

  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(actionGetCategorias());
  }, [dispatch]);


  const AgregarCategoria=(values)=>{
    setTimeout(() => {
      dispatch(actionAgregarCategoria(values));
      showModal(false)
   }, 500);
  }

    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="titulo" component={InputField} ph="Titulo del producto" validate={[required]} />
        <Field name="descripcion" component={textArea} ph="Descripcion" validate={[required]} />
        <Button type="primary" size="small"  icon="plus" onClick={() => showModal(true)} >Agregar categoria</Button>
          <Modal
            title="Agregar Categoria"
            visible={visible}
            onOk={() => showModal(false)}
            onCancel={() => showModal(false)}
            footer={false}
          >
           <FormAgregarCategoria registro={AgregarCategoria}/>
          </Modal>
          <Field name="categorias" component={FieldSelectNormalEditar} ph="Categorias" validate={[required]} >
            {
              categorias && categorias.length > 0
                ? categorias.map((c, key) => (
                  <Option key={c.id} value={c.id}>{c.categoria}</Option>
                ))
                : (
                  <Option key={1} value={1} >No existen categorias</Option>
                )
            }
          </Field>
          
          
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
  }

const mapStateToProps = (state, props) => {
  return {
    //initialValues:props.data
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 
  }
}
export default connect(mapStateToProps, mapDispatchToProps)( reduxForm({ form: 'FormAgregarProducto' })(FormAgregarProducto))